import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { apiConstant } from '../app.constant';
import { ActiveContractors } from '../app.model';


@Injectable({
  providedIn: 'root'
})
export class ActiveContractorsService {

  public baseUrl = `${environment.baseUrl}`;
  constructor(private http: HttpClient) { }


  getActiveContractors(filters: any = []) {

    let apiUrl = this.baseUrl + apiConstant.ACTIVE_CONTRACTORS + '?';

    if (filters.search != undefined) {
      apiUrl += '&search=' + filters.search;
    }
    if (filters.month != undefined) {
      apiUrl += '&month=' + filters.month;
    }
    if (filters.year != undefined) {
      apiUrl += '&year=' + filters.year;
    }



    return this.http.get<ActiveContractors>(apiUrl);
  }

}
